import { Box, Button, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { GetReadyIcon } from '../../../assets/icons';
import { isMobileDevice } from '../../../helpers/device';
import styles from './ParticipantVideoPreview.module.css';

const MeetingEndsView: FC = () => {
  const handleClickMessage = () => {
    const MOBILE_CHAT_URL = 'com.enara://chat';
    const MAIL_TO_URL =
      'mailto:?subject=Reschedule%20request&body=Hi%2C%20I%20tried%20to%20join%20a%20meeting%20that%20has%20finished.%20Could%20we%20reschedule%3F';

    const isMobile = isMobileDevice();
    window.location.href = !isMobile ? MAIL_TO_URL : MOBILE_CHAT_URL;
  };

  return (
    <Box className={styles.videoPreviewContainer}>
      <Paper className={styles.videoPreviewContent}>
        <img src={GetReadyIcon} alt='get-ready-icon' className={styles.meetingEndedImage} />
        <Typography variant='h6'>The meeting you tried to join has finished.</Typography>
        <Typography fontSize={14} fontWeight={300}>
          Need to reschedule or have questions?
        </Typography>
        <Button variant='contained' onClick={handleClickMessage}>
          Message your Provider
        </Button>
      </Paper>
    </Box>
  );
};

export default MeetingEndsView;
